import { createReducer, createActions } from 'reduxsauce'

export const { Types, Creators } = createActions({
  loginRequest: null,
  loginSuccess: ['userInfo'],
  loginFail: ['error'],

  logoutRequest: null,
  logoutSuccess: null,

  reauthRequired: null,
  reauthResolved: null,

  clear: null,
})

export const AuthTypes = Types
export default Creators

const INITIAL_STATE = {
  isAuthInProgress: false,
  isUserLoggedIn: false,
  userInfo: {},
  error: '',
  needsReauth: false,
}

const fetchRequest = state => ({
  ...state,
  isAuthInProgress: true,
  error: '',
})

const loginSuccess = (state, action) => ({
  ...state,
  userInfo: action.userInfo,
  isAuthInProgress: false,
  isUserLoggedIn: true,
})

const loginFail = (state, action) => ({
  ...state,
  error: action.error,
  isAuthInProgress: false,
})

const clear = () => INITIAL_STATE

const reauthRequired = state => ({
  ...state,
  needsReauth: true,
  isAuthInProgress: false,
})

const reauthResolved = state => ({
  ...state,
  needsReauth: false,
})

const HANDLERS = {
  [Types.LOGIN_REQUEST]: fetchRequest,
  [Types.LOGIN_SUCCESS]: loginSuccess,
  [Types.LOGIN_FAIL]: loginFail,

  [Types.LOGOUT_REQUEST]: fetchRequest,
  [Types.LOGOUT_SUCCESS]: clear,

  [Types.REAUTH_REQUIRED]: reauthRequired,
  [Types.REAUTH_RESOLVED]: reauthResolved,

  [Types.CLEAR]: clear,
}

export const reducer = createReducer(INITIAL_STATE, HANDLERS)
